// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_Y9dim {}

.contentHeaderFlex_Y5DFv {
  padding-top: 8px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 8px;
  background-color: white;
  border-bottom: 1px solid var(--color-base100);
}

.contentArea_tJ7ag {
  padding-top: 8px;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.padding_VmJMH {
  padding: 16px !important;
}

.name_WX1Cy, .roles_d17L7 {
  font-weight: 600 !important;
}

.roles_d17L7 {
  color: var(--color-base600) !important;
}

.usersCount_mxW9k {
  font-weight: 700;
  color: var(--color-base600) !important;
}

.validPhone_NQ3MT {
  color: var(--color-success700) !important;
}

.invalidPhone_Sw909 {
  color: var(--color-danger700) !important;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/salesFlow/screens/PendingSaleMessageUserList.css"],"names":[],"mappings":"AAAA,gBAAU;;AAEV;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":[".content {}\n\n.contentHeaderFlex {\n  padding-top: 8px;\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-bottom: 8px;\n  background-color: white;\n  border-bottom: 1px solid var(--color-base100);\n}\n\n.contentArea {\n  padding-top: 8px;\n  padding-left: 16px;\n  padding-right: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.padding {\n  padding: 16px !important;\n}\n\n.name, .roles {\n  font-weight: 600 !important;\n}\n\n.roles {\n  color: var(--color-base600) !important;\n}\n\n.usersCount {\n  font-weight: 700;\n  color: var(--color-base600) !important;\n}\n\n.validPhone {\n  color: var(--color-success700) !important;\n}\n\n.invalidPhone {\n  color: var(--color-danger700) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_Y9dim`,
	"contentHeaderFlex": `contentHeaderFlex_Y5DFv`,
	"contentArea": `contentArea_tJ7ag`,
	"padding": `padding_VmJMH`,
	"name": `name_WX1Cy`,
	"roles": `roles_d17L7`,
	"usersCount": `usersCount_mxW9k`,
	"validPhone": `validPhone_NQ3MT`,
	"invalidPhone": `invalidPhone_Sw909`
};
export default ___CSS_LOADER_EXPORT___;
